import React from "react";
import { Layout } from "antd";
import KeywordResearchForm from "../KeywordResearchForm";
import KeywordResearch from "../KeywordResearch";
import WebsiteIndexEntryTabs from "../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs";


export default function KeywordResearchPage() {
    return (
        <Layout.Content className="general-layout-content">
            <KeywordResearchForm />
            <WebsiteIndexEntryTabs>
                <KeywordResearch />
            </WebsiteIndexEntryTabs>
        </Layout.Content>
    );
}
